import { render, staticRenderFns } from "./Licensed.vue?vue&type=template&id=25e4ec9a&scoped=true"
import script from "./Licensed.vue?vue&type=script&lang=js"
export * from "./Licensed.vue?vue&type=script&lang=js"
import style0 from "./Licensed.vue?vue&type=style&index=0&id=25e4ec9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e4ec9a",
  null
  
)

export default component.exports